import styled from 'styled-components';

import { InfoIcon } from '@root/styles/icons';
import { media } from 'styled-bootstrap-grid';
import { Body1 } from '../../components/Typography';

export const TelephoneOnlyHeading = styled(Body1)`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spaces.space5} 0;
  font-size: 20px;
`;

export const FormWrapper = styled.div`
  padding: 0 15px;
`;

export const InfoCircleIcon = styled(InfoIcon)`
  margin-right: 8px;
  color: ${({ theme }) => theme.customColors.primary};
`;

export const FormBox = styled.div`
  ${media.md`
  padding: 21px 26px;
  border: 1px solid #efefef;
  border-radius: 3px;
`};
`;
